module.exports = __webpack_public_path__ + "img/drops_320.076269de.png";